module.exports = __webpack_public_path__ + "static/caffe_latte@2x-1bfbe34a2bb18d6fe903dae154f0e86d.png";